import { createAsyncThunk } from '@reduxjs/toolkit';
import { useCustomAxios } from '../../shared/lib/customAxios';
import { ISignin } from '../../shared/models/signin';

export const signinApi = createAsyncThunk(
  'user/signin',
  async (reqBody: ISignin) => {
    const { axiosPost, axiosGet } = useCustomAxios();

    try {
      const response = await axiosPost('/authenticator/login', reqBody);
      //const locationsResp = await axiosGet('/common/getAllGeoLocations');

      const defaultConfig = {
        headers: {
          Authorization: `Bearer ${response?.data?.authorizationToken}`,
          "x-source": "SOCIETYPORTAL"
        },
      };

      const userDetails = await axiosGet(
        `/party/${response.data.party._id}`,
        defaultConfig
      );

      /* const tempLoc = locationsResp?.data.reduce((accum: any, curr: any) => {
         accum[curr.stateName] = curr.districts;
         return accum;
       }, {});*/

      return {
        data: {
          ...response.data,
          //location: tempLoc,
          location: [],
          userName:
            userDetails?.data?.details?.name ||
            userDetails?.data?.details?.groupName,
        },
        statusCode: response.status,
      };
    } catch (error: any) {
      return {
        error: error.response.data.message,
        statusCode: error.response.status,
      };
    }
  }
);

export const verifyToken = createAsyncThunk('verifyToken', async () => {
  const { axiosPost } = useCustomAxios();

  try {
    const response = await axiosPost('authenticator/verifyTokenV2', {});
    return { data: response.data, status: response.status };
  } catch (error: any) {
    return { data: error.response.data, status: error.response.status };
  }
});
